export const routes = (prefix = `reports`, pre = `patients`) => [
    {
        name: `${prefix}.${pre}.current-inpatients-report.index`,
        path: `/${prefix}/${pre}/current-inpatients-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.current-inpatients-report.index`,
                PageDescription: "Patient Reports: Current Inpatients report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.current-inpatients-report.index`,
        path: `/${prefix}/${pre}/current-inpatients-report/print`,
        component: () => import('./prints/InpatientReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.current-inpatients-report.index`,
                PageDescription: "Patient Reports: Current Inpatients report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.print.interim-bill.index`,
        path: `/${prefix}/${pre}/interim-bill/print`,
        component: () => import('./prints/InterimBill.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.current-inpatients-report.index`,
                PageDescription: "Patient Reports: Current Inpatients report",
            },
            print: true,
        },
    },
];